import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import emailjs from "emailjs-com";
// import Header from "./Header";
import { Container, Row, Col, Form, Button, Carousel } from "react-bootstrap";

function ThankYou() {
  const location = useLocation();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wqxvvyb", // ✅ Your Service ID
        "template_qkofn8e", // ✅ Your Template ID
        form.current,
        "vwNB5WM_83ykdcls0", // ✅ Your Public Key
      )
      .then(
        () => {
          alert("✅ Thank you! Your form has been submitted.");
          form.current.reset();
        },
        (error) => {
          alert("❌ Something went wrong. Please try again.");
          console.error(error.text);
        },
      );
  };

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <Container className="mb-10">
        <Row>
          <h4 className="fw-bold ">Thank You Cards</h4>
          <br />
          <br />
          <Col
            md={12}
            lg={6}
            className="justify-content-center align-items-center d-flex mb-5 me-3 "
          >
            <Carousel
              indicators={false}
              controls={true}
              data-bs-theme="dark"
              className="w-100 custom-carousel col-with-border d-flex align-items-center justify-content-center"
            >
              <Carousel.Item>
                <p className="text-center p-4 ">
                  “Therapy is worth it. Therapy takes time and Prerna knows how
                  to make it a space that is the best for you. I felt safe,
                  heard, supported and in touch with my emotions - some things I
                  hadn't felt for a long time before I came to therapy with
                  Prerna."
                </p>
              </Carousel.Item>

              <Carousel.Item>
                <p className="text-center p-4">
                  “My favourite thing about Prerna and therapy with her is how
                  collaborative it is. She made me realise how my thoughts,
                  emotions and opinions matter. She helped me build a deeper
                  connection with myself as we worked through trauma, depression
                  and anxiety in my life. She helped me to accept myself. She
                  helped me to love myself. She helped me to find myself!”
                </p>
              </Carousel.Item>

              <Carousel.Item>
                <p className="text-center p-4">
                  “I am so glad and grateful that I reached out to Prerna for my
                  mental health. She understood my concerns well and helped me
                  throughout the process. I was able to find myself and
                  understand myself because of her. I am in a much better space
                  now thanks to her.”
                </p>
              </Carousel.Item>
              <Carousel.Item>
                <p className="text-center p-4">
                  “Prerna helped me and healed me. I don't know how to describe
                  it best. She saved me. Therapy with her came in as a ray of
                  hope in my life and it was a long journey but I am happy and
                  healthy. My favourite thing was how Prerna works on holistic
                  wellness. She understands the relationship between our mind
                  and body so well and works on overall wellbeing and healing. I
                  have so much gratitude and good thoughts for her.”
                </p>
              </Carousel.Item>
              <Carousel.Item>
                <p className="text-center p-4">
                  “I have tried therapy several times before but it never helped
                  me. But I really needed help as I was going through a tough
                  time, so I decided to give it one more go, and I am glad that
                  I did that! Ms Prerna really helped me with practices that are
                  beneficial for me in controlling and dealing with my anger
                  issues. With her suggestions and guidance, I am able to work
                  better on problems and focus on my mental health in more
                  practical ways. She was very good in terms of patiently
                  listening and understanding what I was going through, she
                  helped me understand myself better. I am so thankful and
                  grateful that I found her and decided to give therapy one more
                  chance!”
                </p>
              </Carousel.Item>
              <Carousel.Item>
                <p className="text-center p-4">
                  “The sessions truly helped me connect with myself and helped
                  me grow as a person. Prerna is non-judgemental and
                  understanding of what I was going through. Overall a great
                  experience.”
                </p>
              </Carousel.Item>
            </Carousel>
          </Col>

          <Col className="mb-5 ms-3">
            <span className="fw-bold ">Therapy In-Take Form</span>
            <br />
            <br />
            <Form className="therapy-form" ref={form} onSubmit={sendEmail}>
              {/* Name */}
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  required
                  name="name"
                  id="name"
                />
              </Form.Group>

              {/* Email */}
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  required
                  name="email"
                  id="email"
                />
              </Form.Group>

              {/* Phone */}
              <Form.Group className="mb-3">
                <Form.Label>Phone Number (WhatsApp)</Form.Label>
                <Form.Control
                  type="tel"
                  placeholder="Enter your WhatsApp number"
                  name="mobile"
                  id="mobile"
                />
              </Form.Group>

              {/* Age */}
              <Form.Group className="mb-3">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter your age"
                  name="age"
                  id="age"
                />
              </Form.Group>

              {/* Gender and Pronouns */}
              <Form.Group className="mb-3">
                <Form.Label>Gender and Pronouns</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your gender and pronouns"
                  required
                  name="gender"
                  id="gender"
                />
              </Form.Group>

              {/* Location */}
              <Form.Group className="mb-3">
                <Form.Label>State and Country of Current Residence</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your location"
                  name="location"
                  id="location"
                />
              </Form.Group>

              {/* Preferred Modality  */}
              <Form.Group className="mb-3">
                <Form.Label>Preferred Modality</Form.Label>
                <Form.Check
                  type="radio"
                  label="Individual Therapy"
                  name="preferred_modality"
                  value="Individual Therapy"
                />
                <Form.Check
                  type="radio"
                  label="Couples Therapy"
                  name="preferred_modality"
                  value="Couples Therapy"
                />
              </Form.Group>

              {/* Reason for therapy */}
              <Form.Group className="mb-3">
                <Form.Label>What brings you to therapy?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Share your reason..."
                  name="reason"
                  id="reason"
                />
              </Form.Group>

              {/* Preferred contact */}
              <Form.Group className="mb-3">
                <Form.Label>What's your preferred mode of contact?</Form.Label>
                <Form.Check
                  type="radio"
                  name="preferred_contact"
                  value="WhatsApp"
                  label="WhatsApp"
                />
                <Form.Check
                  type="radio"
                  name="preferred_contact"
                  value="Email"
                  label="Email"
                />
              </Form.Group>

              {/* How did you find */}
              <Form.Group className="mb-3">
                <Form.Label>How did you find ScopeWithin?</Form.Label>
                <Form.Check
                  type="radio"
                  name="found_us"
                  value="Returning to therapy"
                  label="Returning to therapy"
                />
                <Form.Check
                  type="radio"
                  name="found_us"
                  value="Referral"
                  label="Referral"
                />
                <Form.Check
                  type="radio"
                  name="found_us"
                  value="Social media"
                  label="Social media"
                />
                <Form.Check
                  type="radio"
                  name="found_us"
                  value="Google"
                  label="Google"
                />
              </Form.Group>

              {/* Messages */}
              <Form.Group className="mb-3">
                <Form.Label>
                  Have any messages or questions? Please share...
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Your message..."
                  name="message"
                  id="message"
                />
              </Form.Group>

              {/* Submit */}
              <div className="text-center">
                <Button type="submit" className="btn-primary">
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ThankYou;
